import { jwtDecode } from 'jwt-decode';

import { generateUserAgentHeader, urls } from '~/utilities/dataHelpers';
import mediator from '~/utilities/mediator';
import { persistAuthSession } from '~/utilities/session';

export const signIn = async ({
  appVersion,
  osType,
  osVersion,
  deviceId,
  phoneNumber,
  password,
}: {
  phoneNumber: string;
  password: string;
  osType: string;
  osVersion: string;
  appVersion: string;
  deviceId: string;
}) => {
  const result = await mediator.request<ApiResponse<AuthResponse>>(
    'api:invoke',
    {
      method: 'POST',
      url: `${urls.accountApiUrl}login`,
      params: {
        include: 'patient',
      },
      headers: {
        'X-User-Agent': generateUserAgentHeader({
          appVersion,
          osType,
          osVersion,
        }),
        'X-Device-ID': deviceId,
      },
      data: {
        phoneNumber,
        password,
      },
    },
  );

  if (result.data) {
    const decodedToken = jwtDecode<{
      accountID: string;
      deviceID: string;
      app: string;
      exp: number;
      iat: number;
      jti: number;
    }>(result.data.accessToken);

    const authSession = {
      ...result.data,
      accessToken: undefined,
      access_token: result.data.accessToken,
      account_id: decodedToken.accountID,
      expires: decodedToken.exp,
    };

    delete authSession.accessToken;

    persistAuthSession({
      access_token: authSession.access_token,
      account_id: authSession.account_id,
      expires: authSession.expires,
      include: result.data.include,
    });

    return authSession;
  }

  throw result;
};
